import { RentalHistorySourceType } from '../../../shared/types/pricingSheets';

export const getRentalHistoryCustomerTypeLabel = (
  type: RentalHistorySourceType,
): string => {
  switch (type) {
    case RentalHistorySourceType.Customer:
      return 'Asiakas';
    case RentalHistorySourceType.CompanyChain:
      return 'Yritysketju';
    default:
      console.warn('Customer type not recognized!');
      return '';
  }
};
